[
  {
    "id": "psychology-of-travel",
    "title": "THE PSYCHOLOGY OF TRAVEL",
    "category": "Travel Research",
    "date": "2026-01-20",
    "excerpt": "When people step outside their everyday patterns, attention expands and decision-making shifts. Grounded in traveler behavior, our research report examines how those mindset changes shape how people plan, experience and remember travel.",
    "image": "/assets-optimized/redesign/insights/popup-image.png",
    "featured": true,
    "buttonText": "Download Now"
  },
  {
    "id": "news-article-1",
    "title": "UNITED AND MARRIOTT PITCH STRATEGIES TO TARGET TRAVELERS",
    "category": "News",
    "date": "2026-01-20",
    "excerpt": "People enter a state of willingness to spend when they're on vacation.",
    "image": "/assets-optimized/redesign/insights/first_article.png",
    "featured": false,
    "buttonText": "",
    "link": "https://skift.com/2026/03/16/united-and-marriott-pitch-ad-strategies-to-target-travelers-on-plane-and-hotel-screens/"
  },
  {
    "id": "video-article-1",
    "title": "THE NEXT EVOLUTION OF HOSPITALITY THROUGH DATA, LOYALTY, AND EXPERIENCE",
    "category": "Video",
    "date": "2026-01-20",
    "excerpt": "Chris Norton, SVP & GM, shares how data, loyalty, and personalization are redefining hospitality—creating experiences that feel more seamless, relevant, and human.",
    "image": "/assets-optimized/redesign/insights/second_article.png",
    "featured": false,
    "buttonText": "",
    "link": "https://www.ces.tech/videos/marriott-international-hits-the-ces-2026-c-space-studio-the-next-evolution-of-hospitality-through-data-loyalty-and-experience/"
  },
  {
    "id": "press-release-1",
    "title": "FAQ ON COMMERCE MEDIA: HOW TO CAPITALIZE ON GROWTH BEYOND RETAIL",
    "category": "Press Releases",
    "date": "2026-01-20",
    "excerpt": "Commerce media extends the retail media playbook to industries beyond traditional retail.",
    "image": "/assets-optimized/redesign/insights/third_article.jpg",
    "featured": false,
    "buttonText": "",
    "link": "https://www.emarketer.com/content/faq-on-commerce-media-how-capitalize-on-growth-beyond-retail"
  }
]
